import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Injectable({
  providedIn: 'root'
})
export class UtcMomentDateAdapterService  extends MomentDateAdapter {
  createDate(year: number, month: number, date: number): moment.Moment {
    if (month < 0 || month > 11) {
      throw Error(
        `Invalid month index "${month}". Month index has to be between 0 and 11.`
      );
    }

    if (date < 1) {
      throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
    }

    // NOTE: This is the crucial change to make dates work for us: `moment.utc()` rather that `moment()`.
    // The code is otherwise exactly the same as that in the MomentDateAdapter.
    const result = moment.utc({ year, month, date }).locale(this.locale);

    if (!result.isValid()) {
      throw Error(`Invalid date "${date}" for month with index "${month}".`);
    }

    return result;
  }

  parse(value: any, parseFormat: string | string[]): moment.Moment | null {
    if (value && typeof value === 'string') {
        return moment.utc(value, 'DD MM YYYY').locale(this.locale);
    }
    return value ? moment(value).locale(this.locale) : null;
  }
}
